import { render, staticRenderFns } from "./QuestionAnswerPageSwitch.vue?vue&type=template&id=53c37cca&scoped=true"
import script from "./QuestionAnswerPageSwitch.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerPageSwitch.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswerPageSwitch.vue?vue&type=style&index=0&id=53c37cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c37cca",
  null
  
)

export default component.exports